// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// A list of cards
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import SwiperCore, { Swiper, Navigation, Pagination, A11y, Keyboard } from 'swiper/core';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/swiper-bundle.css';
import './_content-cards.scss';

// Install modules
SwiperCore.use([Swiper, Navigation, Pagination, A11y, Keyboard]);

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleContentCardSlides(swiperEl) {
  swiperEl.slides.forEach(function (slide, index) {
    let slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function (e) {
      swiperEl.slideTo(index);
    })
  });
}

$(function () {
  $(".carousel--content-card").each(function (index, element) {
    var $this = $(this);

    // Generate unique class for each feature card slider
    $this.addClass("content-card-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.content-cards-section').find(".swiper-pagination").addClass("content-cards-swiper-pagination-" + index);
    $this.parents('.content-cards-section').find(".swiper-button-prev").addClass("content-cards-btn-prev-" + index);
    $this.parents('.content-cards-section').find(".swiper-button-next").addClass("content-cards-btn-next-" + index);

    // Initialize feature card slider based on the unique classes generated above.
    var swiper = new Swiper(".content-card-instance-" + index, {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      a11y: false,
      watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

      breakpoints: {
        // when window width is >= 680px
        680: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 6
        }
      },
       // // Navigation arrows
       navigation: {
        nextEl: ".content-cards-btn-next-" + index,
        prevEl: ".content-cards-btn-prev-" + index
      },

        pagination: {
            el: ".content-cards-swiper-pagination-" + index,
            type: 'bullets',
            clickable: true,
        },
    });

    swiper.slides.forEach(function(slide, index) {
      slide.addEventListener('focus', function(e) {
          swiper.slideTo(index);
        })
    });
  });
});
